import React from 'react';
import { LayoutGroup, motion, useReducedMotion } from 'framer-motion';
import './BillingPeriodToggle.css';

const PILL_SPRING = {
  type: 'spring',
  stiffness: 380,
  damping: 26,
  mass: 0.95,
};

/** Segmented control for monthly vs yearly display and checkout. */
export function BillingPeriodToggle({ value, onChange, className = '' }) {
  const reducedMotion = useReducedMotion();
  const pillTransition = reducedMotion ? { duration: 0 } : PILL_SPRING;

  return (
    <LayoutGroup id="billing-period-toggle">
      <div
        className={`pricing-billing-toggle ${className}`.trim()}
        role="group"
        aria-label="Billing period"
      >
      <button
        type="button"
        className={`pricing-billing-toggle-btn${value === 'month' ? ' is-selected' : ''}`}
        aria-pressed={value === 'month'}
        onClick={() => onChange('month')}
      >
        {value === 'month' ? (
          <motion.span
            layoutId="billing-period-pill"
            className="pricing-billing-toggle-pill"
            transition={pillTransition}
            aria-hidden="true"
          />
        ) : null}
        <span className="pricing-billing-toggle-label">Monthly</span>
      </button>
      <button
        type="button"
        className={`pricing-billing-toggle-btn${value === 'year' ? ' is-selected' : ''}`}
        aria-pressed={value === 'year'}
        onClick={() => onChange('year')}
      >
        {value === 'year' ? (
          <motion.span
            layoutId="billing-period-pill"
            className="pricing-billing-toggle-pill"
            transition={pillTransition}
            aria-hidden="true"
          />
        ) : null}
        <span className="pricing-billing-toggle-label">Annually</span>
      </button>
      </div>
    </LayoutGroup>
  );
}
